"use client";

import LogoIcon from "@/components/atoms/svg/LogoIcon";
import BackgroundVideo from "@/components/molecules/BackgroundVideo";
import { useEffect } from "react";
type Props = {
  error: Error;
  reset(): void;
};

export default function Error({ error }: Props) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="wrapper w-full h-screen justify-center items-center flex-col flex gap-16">
      <div className="flex flex-col gap-6 md:gap-[52px] justify-center items-center max-w-[758px] text-center">
        <div className="max-w-[74px] mx-auto">
          <LogoIcon className="w-full" />
        </div>
        <div className="text-5xl text-base-quaternary/60 font-medium">
          Oops! Something went wrong.
          <div className="text-2xl text-base-quaternary/25 font-medium mt-2">
            Seem like the codes are not working as expected.
          </div>
        </div>
      </div>
      <BackgroundVideo />
    </div>
  );
}
